import {
	FETCH_PATCHNOTES_BEGIN,
	FETCH_PATCHNOTES_SUCCESS,
	FETCH_PATCHNOTES_ERROR,
} from "../actions/patchnotesActions"

const initialState = {
	patchnotes: [],
	fetchPatchnotes: {
		loading: false,
		error: false,
	},
}

export default function patchnotesReducer(state = initialState, action) {
	switch (action.type) {
		case FETCH_PATCHNOTES_BEGIN:
			return {
				...state,
				fetchPatchnotes: { loading: true, error: false },
			}
		case FETCH_PATCHNOTES_SUCCESS:
			return {
				...state,
				patchnotes: action.payload,
				fetchPatchnotes: { loading: false, error: false },
			}
		case FETCH_PATCHNOTES_ERROR:
			return {
				...state,
				fetchPatchnotes: { loading: false, error: action.payload },
			}
		default:
			return state
	}
}
